export default "__VITE_ASSET__6Ce5GxC$__"